class PersonalStageController {
  constructor($scope){
    this.$scope = $scope

    $scope.arrowImageUrl = require("@amount/frontend-styles/src/images/dec/dec-rates-arrow.svg");
  }
}

PersonalStageController.$inject = ["$scope"];

module.exports = PersonalStageController
